// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from "jspdf";
// import { Worker, Viewer } from "@react-pdf-viewer/core"; // Import components from @react-pdf-viewer
// import * as pdfjs from "pdfjs-dist/webpack"; // Import pdfjs from pdfjs-dist directly
// import nvmLogo from "../../assets/Photos/nvmlogo.jpg"; // Ensure you have the correct logo path
// import "@react-pdf-viewer/core/lib/styles/index.css"; // Import styles for the PDF viewer

// // Set the worker path explicitly for pdf.js
// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// const DownloadPage = () => {
//   const location = useLocation();
//   const { currentAdmission } = location.state || {}; // Extract admission details
//   const navigate = useNavigate();
//   const [pdfDataUrl, setPdfDataUrl] = useState(null); // State to hold the PDF data URL

//   // Function to generate the PDF using jsPDF
//   const generatePDF = () => {
//     const doc = new jsPDF();

//     // Set font to Helvetica, bold
//     doc.setFont("helvetica", "bold");

//     // Add the logo at the top
//     doc.addImage(nvmLogo, "jpg", 50, 10, 20, 20);

//     // School Name in heading, centered
//     const schoolName = "Nalanda Vidhya Mandir";
//     const schoolNamePageWidth = doc.internal.pageSize.width;
//     const schoolNameTextWidth = doc.getTextWidth(schoolName);
//     const centerSchoolName = (schoolNamePageWidth - schoolNameTextWidth) / 2; // Center the text
//     doc.setFontSize(20);
//     doc.text(schoolName, centerSchoolName, 20); // (x, 20) places it at the top-center

//     // School Address
//     const schoolAddress = "Sanothimi, Bhaktapur";
//     doc.setFontSize(14);
//     doc.text(schoolAddress, 85, 27); // (x, 20) places it at the top-center

//     // Line separation
//     const lineY = 35;
//     doc.setLineWidth(0.5);
//     doc.line(10, lineY, schoolNamePageWidth - 10, lineY);

//     // Title: Admission Details, with underline
//     const title = "Admission Details";
//     const titlePageWidth = doc.internal.pageSize.width;
//     const titleTextWidth = doc.getTextWidth(title);
//     const centerTitle = (titlePageWidth - titleTextWidth) / 2;
//     doc.line(centerTitle, 47, centerTitle + titleTextWidth + 6, 47);
//     doc.setFontSize(16);
//     doc.text(title, centerTitle, 45);

//     // Title: Student Details, with underline
//     doc.setFontSize(14);
//     doc.setFont("Helvetica", "bold");
//     doc.text("Student Details", 10, 55);
//     doc.line(10, 56, 46, 56);

//     // Title: Father Details, with underline
//     doc.setFontSize(14);
//     doc.setFont("Helvetica", "bold");
//     doc.text("Father Details", 10, 118);
//     doc.line(10, 119, 43, 119);

//     // Title: Mother Details, with underline
//     doc.setFontSize(14);
//     doc.setFont("Helvetica", "bold");
//     doc.text("Mother Details", 120, 118);
//     doc.line(120, 119, 154, 119);

//     // Title: Guardian Details, with underline
//     doc.setFontSize(14);
//     doc.setFont("Helvetica", "bold");
//     doc.text("Guardian Details", 10, 168);
//     doc.line(10, 169, 49, 169);

//     //Importing all the data of the student personal details
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(12);
//     const {
//       first_name,
//       middle_name,
//       last_name,
//       dob,
//       classEnrolled,
//       nationality,
//       address,
//       previous_school,
//     } = currentAdmission.personal_details;

//     //Displaying the Student Name
//     const studentName =
//       middle_name && middle_name.length > 0
//         ? `${first_name} ${middle_name} ${last_name}`
//         : `${first_name} ${last_name}`;

//     // Set font to bold for titles like name, dob, class, nationality, address, previous school
//     doc.setFont("Helvetica", "bold");
//     doc.text("Name:", 10, 62);
//     doc.text("DOB:", 10, 69.5);
//     doc.text("Class: ", 10, 77);
//     doc.text("Nationality: ", 10, 84.5);
//     doc.text("Address: ", 10, 92);
//     doc.text("Previous School: ", 10, 99.5);

//     //Contents of each data of the student personal details
//     doc.setFont("Helvetica", "normal");
//     doc.text(`${studentName}`, 50, 62);
//     doc.text(`${dob}`, 50, 69.5);
//     doc.text(`${classEnrolled}`, 50, 77);
//     doc.text(`${nationality}`, 50, 84.5);
//     doc.text(`${address}`, 50, 92);
//     doc.text(`${previous_school}`, 50, 99.5);

//     //Importing all the necessary data from the student's father details
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(12);
//     const { full_name, email, occupation, number } =
//       currentAdmission.fathers_details;

//     // Set font to bold for titles like name, dob, class, nationality, address, previous school
//     doc.setFont("Helvetica", "bold");
//     doc.text("Name:", 10, 127);
//     doc.text("Email:", 10, 134.5);
//     doc.text("Occupation: ", 10, 142);
//     doc.text("Number: ", 10, 149.5);

//     //Contents of each data of the student personal details
//     doc.setFont("Helvetica", "normal");
//     doc.text(`${full_name}`, 40, 127);
//     doc.text(`${email}`, 40, 134.5);
//     doc.text(`${occupation}`, 40, 142);
//     doc.text(`${number}`, 40, 149.5);

//     //Importing all the necessary data from the student's mother details
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(12);
//     const {
//       full_name: motherName,
//       email: motherEmail,
//       occupation: motherOccupation,
//       number: motherNumber,
//     } = currentAdmission.mothers_details;

//     // Set font to bold for titles like name, dob, class, nationality, address, previous school
//     doc.setFont("Helvetica", "bold");
//     doc.text("Name:", 120, 127);
//     doc.text("Email:", 120, 134.5);
//     doc.text("Occupation: ", 120, 142);
//     doc.text("Number: ", 120, 149.5);

//     //Contents of each data of the student personal details
//     doc.setFont("Helvetica", "normal");
//     doc.text(`${motherName}`, 150, 127);
//     doc.text(`${motherEmail}`, 150, 134.5);
//     doc.text(`${motherOccupation}`, 150, 142);
//     doc.text(`${motherNumber}`, 150, 149.5);

//     //Importing all the necessary data from the student's mother details
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(12);
//     const {
//       full_name: guardianName,
//       relation: guardianRelation,
//       occupation: guardianOccupation,
//       number: guardianContact,
//       address: guardianAddress,
//     } = currentAdmission.guardian_details;

//     // Set font to bold for titles like name, dob, class, nationality, address, previous school
//     doc.setFont("Helvetica", "bold");
//     doc.text("Name:", 10, 177);
//     doc.text("Relation:", 10, 184.5);
//     doc.text("Occupation: ", 10, 192);
//     doc.text("Address: ", 10, 199.5);
//     doc.text("Number: ", 10, 207);

//     //Contents of each data of the student personal details
//     doc.setFont("Helvetica", "normal");
//     doc.text(`${guardianName}`, 40, 177);
//     doc.text(`${guardianRelation}`, 40, 184.5);
//     doc.text(`${guardianOccupation}`, 40, 192);
//     doc.text(`${guardianAddress}`, 40, 199.5);
//     doc.text(`${guardianContact}`, 40, 207);

//     const { createdAt, other } = currentAdmission;

//     // Create a new Date object from createdAt
//     const date = new Date(createdAt);

//     // Format the date as "year/month/day"
//     const formattedDate = `${date.getFullYear()} - ${(date.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")} - ${date.getDate().toString().padStart(2, "0")}`;

//     doc.setFont("Helvetica", "bold");
//     doc.text("Other data: ", 10, 225);
//     doc.text("Submission Date: ", 10, 260);

//     doc.setFont("Helvetica", "normal");

//     // Set the width limit for the text
//     const maxWidth = 150; // Adjust this value to fit your page layout

//     // Automatically wrap the text within the given width
//     const textToWrap = `${other}`;

//     const wrappedText = doc.splitTextToSize(textToWrap, maxWidth);

//     // Render the wrapped text
//     doc.text(wrappedText, 50, 225);

//     // Display the formatted date
//     doc.text(formattedDate, 50, 260); // Adjust the Y position based on how many lines of text

//     //Create a Data URL from the generated PDF
//     const pdfDataUrl = doc.output("datauristring");
//     setPdfDataUrl(pdfDataUrl);

//     // doc.save(
//     //   `${currentAdmission.personal_details.first_name} ${currentAdmission.personal_details.middle_name} ${currentAdmission.personal_details.last_name} - class${currentAdmission.personal_details.classEnrolled} - year${currentAdmission.createdAt}`
//     // );
//   };

//   // Trigger PDF generation once the currentAdmission data is available
//   useEffect(() => {
//     if (currentAdmission) {
//       generatePDF();
//       // Redirect after PDF is generated
//       // setTimeout(() => {
//       //   navigate("/nvm-admin/admission");
//       // }, 2000); // Redirect after 2 seconds
//     }
//   }, [currentAdmission, navigate]);

//   return (
//     <div className="text-center">
//       <h2 className="text-3xl font-semibold mb-6">Displaying PDF...</h2>
//       {pdfDataUrl ? (
//         <div style={{ marginLeft: "300px", height: "500px", width: "50%" }}>
//           <Viewer fileUrl={pdfDataUrl} />
//         </div>
//       ) : (
//         <p>Loading PDF...</p>
//       )}
//     </div>
//   );
// };

// export default DownloadPage;

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import { useNavigate } from "react-router-dom";
import nvmLogo from "../../assets/Photos/nvmlogo.jpg"; // Ensure you have the correct logo path
const DownloadPage = () => {
  const location = useLocation();
  const { currentAdmission } = location.state || {};
  const navigate = useNavigate();
  const downloadAsPDF = () => {
    const doc = new jsPDF();

    // Set font to Helvetica, bold
    doc.setFont("helvetica", "bold");

    // Add the logo at the top
    doc.addImage(nvmLogo, "jpg", 50, 10, 20, 20);

    // School Name in heading, centered
    const schoolName = "Nalanda Vidhya Mandir";
    const schoolNamePageWidth = doc.internal.pageSize.width;
    const schoolNameTextWidth = doc.getTextWidth(schoolName);
    const centerSchoolName = (schoolNamePageWidth - schoolNameTextWidth) / 2; // Center the text
    doc.setFontSize(20);
    doc.text(schoolName, centerSchoolName, 20); // (x, 20) places it at the top-center

    // School Address
    const schoolAddress = "Sanothimi, Bhaktapur";
    doc.setFontSize(14);
    doc.text(schoolAddress, 85, 27); // (x, 20) places it at the top-center

    // Line separation
    const lineY = 35;
    doc.setLineWidth(0.5);
    doc.line(10, lineY, schoolNamePageWidth - 10, lineY);

    // Title: Admission Details, with underline
    const title = "Admission Details";
    const titlePageWidth = doc.internal.pageSize.width;
    const titleTextWidth = doc.getTextWidth(title);
    const centerTitle = (titlePageWidth - titleTextWidth) / 2;
    doc.line(centerTitle, 47, centerTitle + titleTextWidth + 6, 47);
    doc.setFontSize(16);
    doc.text(title, centerTitle, 45);

    // Title: Student Details, with underline
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text("Student Details", 10, 55);
    doc.line(10, 56, 46, 56);

    // Title: Father Details, with underline
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text("Father Details", 10, 118);
    doc.line(10, 119, 43, 119);

    // Title: Mother Details, with underline
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text("Mother Details", 120, 118);
    doc.line(120, 119, 154, 119);

    // Title: Guardian Details, with underline
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text("Guardian Details", 10, 168);
    doc.line(10, 169, 49, 169);

    //Importing all the data of the student personal details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const {
      first_name,
      middle_name,
      last_name,
      dob,
      classEnrolled,
      nationality,
      address,
      previous_school,
    } = currentAdmission.personal_details;

    //Displaying the Student Name
    const studentName =
      middle_name && middle_name.length > 0
        ? `${first_name} ${middle_name} ${last_name}`
        : `${first_name} ${last_name}`;

    // Set font to bold for titles like name, dob, class, nationality, address, previous school
    doc.setFont("Helvetica", "bold");
    doc.text("Name:", 10, 62);
    doc.text("DOB:", 10, 69.5);
    doc.text("Class: ", 10, 77);
    doc.text("Nationality: ", 10, 84.5);
    doc.text("Address: ", 10, 92);
    doc.text("Previous School: ", 10, 99.5);

    //Contents of each data of the student personal details
    doc.setFont("Helvetica", "normal");
    doc.text(`${studentName}`, 50, 62);
    doc.text(`${dob}`, 50, 69.5);
    doc.text(`${classEnrolled}`, 50, 77);
    doc.text(`${nationality}`, 50, 84.5);
    doc.text(`${address}`, 50, 92);
    doc.text(`${previous_school}`, 50, 99.5);

    //Importing all the necessary data from the student's father details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const { full_name, email, occupation, number } =
      currentAdmission.fathers_details;

    // Set font to bold for titles like name, dob, class, nationality, address, previous school
    doc.setFont("Helvetica", "bold");
    doc.text("Name:", 10, 127);
    doc.text("Email:", 10, 134.5);
    doc.text("Occupation: ", 10, 142);
    doc.text("Number: ", 10, 149.5);

    //Contents of each data of the student personal details
    doc.setFont("Helvetica", "normal");
    doc.text(`${full_name}`, 40, 127);
    doc.text(`${email}`, 40, 134.5);
    doc.text(`${occupation}`, 40, 142);
    doc.text(`${number}`, 40, 149.5);

    //Importing all the necessary data from the student's mother details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const {
      full_name: motherName,
      email: motherEmail,
      occupation: motherOccupation,
      number: motherNumber,
    } = currentAdmission.mothers_details;

    // Set font to bold for titles like name, dob, class, nationality, address, previous school
    doc.setFont("Helvetica", "bold");
    doc.text("Name:", 120, 127);
    doc.text("Email:", 120, 134.5);
    doc.text("Occupation: ", 120, 142);
    doc.text("Number: ", 120, 149.5);

    //Contents of each data of the student personal details
    doc.setFont("Helvetica", "normal");
    doc.text(`${motherName}`, 150, 127);
    doc.text(`${motherEmail}`, 150, 134.5);
    doc.text(`${motherOccupation}`, 150, 142);
    doc.text(`${motherNumber}`, 150, 149.5);

    //Importing all the necessary data from the student's mother details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const {
      full_name: guardianName,
      relation: guardianRelation,
      occupation: guardianOccupation,
      number: guardianContact,
      address: guardianAddress,
    } = currentAdmission.guardian_details;

    // Set font to bold for titles like name, dob, class, nationality, address, previous school
    doc.setFont("Helvetica", "bold");
    doc.text("Name:", 10, 177);
    doc.text("Relation:", 10, 184.5);
    doc.text("Occupation: ", 10, 192);
    doc.text("Address: ", 10, 199.5);
    doc.text("Number: ", 10, 207);

    //Contents of each data of the student personal details
    doc.setFont("Helvetica", "normal");
    doc.text(`${guardianName}`, 40, 177);
    doc.text(`${guardianRelation}`, 40, 184.5);
    doc.text(`${guardianOccupation}`, 40, 192);
    doc.text(`${guardianAddress}`, 40, 199.5);
    doc.text(`${guardianContact}`, 40, 207);

    const { createdAt, other } = currentAdmission;

    // Create a new Date object from createdAt
    const date = new Date(createdAt);

    // Format the date as "year/month/day"
    const formattedDate = `${date.getFullYear()} - ${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")} - ${date.getDate().toString().padStart(2, "0")}`;

    doc.setFont("Helvetica", "bold");
    doc.text("Other data: ", 10, 225);
    doc.text("Submission Date: ", 10, 260);

    doc.setFont("Helvetica", "normal");

    // Set the width limit for the text
    const maxWidth = 150; // Adjust this value to fit your page layout

    // Automatically wrap the text within the given width
    const textToWrap = `${other}`;

    const wrappedText = doc.splitTextToSize(textToWrap, maxWidth);

    // Render the wrapped text
    doc.text(wrappedText, 50, 225);

    // Display the formatted date
    doc.text(formattedDate, 50, 260); // Adjust the Y position based on how many lines of text

    // Add other fields similarly
    doc.save(
      `${currentAdmission.personal_details.first_name} ${currentAdmission.personal_details.middle_name} ${currentAdmission.personal_details.last_name} - class${currentAdmission.personal_details.classEnrolled} - year${currentAdmission.createdAt}`
    );
  };

  useEffect(() => {
    if (currentAdmission) {
      downloadAsPDF();
      setTimeout(() => {
        navigate("/nvm-admin/admission"); // Redirect back to the admission page or wherever you want
      }, 2000); // Wait 1 second before redirecting (optional)
    }
  }, [currentAdmission]);

  return (
    <div className="text-center">
      <h2 className="text-3xl font-semibold mb-6">Downloading PDF...</h2>
    </div>
  );
};

export default DownloadPage;
